import React, { useState } from "react";

import Container from "../components/Container";
import ContentTemplate from "../components/Layout/contentTemplate";
import { Context } from "../utils/store";
import Head from "next/head";
import ImprintComponent from "../components/Imprint";
import Layout from "../components/Layout";
import TopicHeader from "../components/TopicHeader";
import fetchRequestLibrary from "../utils/fetchRequestLibrary";
import { siteTitle } from "../components/Layout";
import { useContext } from "react";
import CustomHead from '../components/CustomHead';

export default function Imprint({ 
    thematiques,
    breakingNews,
    cities,
    ephemeralChannels,
    liveData,
    medias,
}) {
    const context = useContext(Context);

    return (
        <Context.Provider
            value={{
                ...context,
                activePage: "imprint",
                thematiques,
                breakingNews,
                cities,
                ephemeralChannels,
                liveData,
                medias,
            }}
        >
            <Layout>
                <Container>
                    <CustomHead title="Mentions légales"/>

                    <ContentTemplate type={"imprint"}>
                        <TopicHeader topic={"Mentions Légales"} type={"imprint"} />
                        <ImprintComponent />
                    </ContentTemplate>
                </Container>
            </Layout>
        </Context.Provider>
    );
}

export async function getServerSideProps(context) {
    const {
        thematiques,
        breakingNews,
        cities,
        ephemeralChannels,
        liveData,
        medias,
    } = await fetchRequestLibrary();

    return {
        props: {
            thematiques,
            breakingNews,
            cities,
            ephemeralChannels,
            liveData,
            medias,
        },
    };
}